import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Modal, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ActivityLog from '../ActivityLog';
import * as Common from "../Common";
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import FaView from '../FaView';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from "../Picklist";
import Tran_data_unlock_request from '../Tran_data_unlock_request';

const Tran_cheque_in_view = () => {

    const sid = sessionStorage.getItem("sessionId");
    const navigate = useNavigate();
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [scrMode, setScrMode] = useState("");

    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isErrBox, setErrBox] = useState(false);
    const [errText, setErrText] = useState("");
    const [showModal, setShowModal] = useState(false);

    const [cbOutFromlocation, setCbOutFromLocation] = useState(null);
    const [cbOutTolocation, setCbOutToLocation] = useState(null);
    const [cbOutBank, setCbOutBank] = useState(null);
    const [radioType, setRadioType] = useState('S');
    const [cbOutdate, setCbOutDate] = useState(new Date());
    const [locationCode, setLocationCode] = useState(0);
    const [toLocationCode, setToLocationCode] = useState(0);
    const [fromLocation, setFromLocation] = useState('');
    const [toLocation, setToLocation] = useState('');
    const [bankName, setBankName] = useState('');
    const [cbOutFromDate, setCbOutFromDate] = useState(new Date());
    const [cbOutToDate, setCbOutToDate] = useState(new Date());
    const [cbOutFromSrNo, setCbOutFromSrno] = useState('');
    const [cbOutToSrno, setCbOutToSrno] = useState('');
    const [groupCode, setGroupCode] = useState(0);
    const [bankCode, setBankCode] = useState(0);

    const [headerData, setHeaderData] = useState([]);
    const [innerData, setInnerData] = useState([]);
    const [subInnerData, setSubInnerData] = useState([]);

    const [cbOutQuantity, setCbOutQuantity] = useState('');
    const [cbOutFrom, setCbOutFrom] = useState('');
    const [cbOutTo, setCbOutTo] = useState('');
    const [srNo, setSrNo] = useState(0);
    const [counter, setCounter] = useState(0);
    const [lineNo, setLineNo] = useState(0);
    const [cbFrom, setCbFrom] = useState("");

    const [viewSrno, setViewSrno] = useState(0);
    const [viewDate, setViewDate] = useState('');
    const currentDate = new Date();

    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });

    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [status, setStatus] = useState('');

    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });
    const [showFaView, setShowFaView] = useState(false);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setCbOutFromLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_CHEQUE_IN_VIEW'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);


    const handleChangeLocation = (value) => {
        setCbOutFromLocation(value);
        var fromloc = value.id.split('^');
        setLocationCode(fromloc[1]);
        setFromLocation(fromloc[2]);
        setCbOutToLocation(null);
        setCbOutBank(null);
        sessionStorage.activeBranch = fromloc[1];
    }

    const list = () => {
        var msg = [], i = 0;
        if (cbOutFromlocation === null || (radioType === 'S' && !cbOutFromSrNo) || (radioType === 'S' && !cbOutToSrno) ||
            (radioType === 'D' && !cbOutFromDate) || (radioType === 'D' && !cbOutToDate)) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (cbOutFromlocation === null ? " Location." : '');
            msg[i++] = (radioType === 'S' && !cbOutFromSrNo ? " From Srno." : '');
            msg[i++] = (radioType === 'S' && !cbOutToSrno ? " To Srno." : '');
            msg[i++] = (radioType === 'D' && !cbOutFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'D' && !cbOutToDate ? " To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                filterRadioType: radioType,
                filterLocation: locationCode,
                filterFromDate: Common.dateYMD(cbOutFromDate),
                filterToDate: Common.dateYMD(cbOutToDate),
                filterFromSrno: cbOutFromSrNo,
                filterToSrno: cbOutToSrno,
            }
            Common.callApi(Common.apitranchequeinview, [sid, 'list', JSON.stringify(obj)], (result) => {
                let resp = JSON.parse(result);
                setHeaderData(resp);
            });
        }
    }

    const viewList = (hdrSrno, location, type, date) => {
        setScrMode('Q');
        setSrNo(hdrSrno);
        setViewDate(date);
        setViewSrno(hdrSrno);
        const obj = {
            srno: hdrSrno,
            location: location,
            type: type,
        }
        Common.callApi(Common.apitranchequeinview, [sid, 'view', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.msg === 'MSG0000') {
                setInnerData(resp.chequeList);
                setLineNo(resp.maxlineno);
                setFromLocation(resp.locationname);
                setToLocation(resp.tolocationname);
                setBankName(resp.ledgername);
                setBankCode(resp.ledgercode);
                setGroupCode(resp.groupcode);
                setToLocationCode(resp.tolocation);
                setCbOutBank({ id: resp.bank });
                setStatus(resp.status);
            }
        });
        console.log(cbOutBank);
    }


    const viewDetails = (srno, lineno, location, type) => {
        const obj = {
            srno: srno,
            lineno: lineno,
            location: location,
            type: type,
        }
        Common.callApi(Common.apitranchequeinview, [sid, 'viewDtls', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setSubInnerData(resp);
        });
        setShowModal(true);
    }


    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
        setCbOutBank(null);
    }

    const handleFaView = () => {
        setShowFaView(true);
        setFaViewObject({ location: locationCode, trannumber: srNo, type: 'CHQINBR' });
    }
    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: 'CHQINBR', trannumber: srNo, trancategory: "T", location: locationCode });
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h2>Cheque From Branch</h2>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                {
                    scrMode === '' ?
                        <>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>From Location<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={cbOutFromlocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleChangeLocation}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-4 col-6'>
                                    <Form.Group>
                                        <Row style={{ marginTop: "30px" }}>
                                            <Col>
                                                <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                            </Col><Col>
                                                <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    radioType === 'S' ?
                                        <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>From<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control value={cbOutFromSrNo}
                                                        maxLength={20}
                                                        onChange={(e) => Common.validateNumValue(e.target.value, setCbOutFromSrno)}
                                                        placeholder="From" />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>To<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control value={cbOutToSrno}
                                                        maxLength={20}
                                                        onChange={(e) => Common.validateNumValue(e.target.value, setCbOutToSrno)}
                                                        placeholder="To" />
                                                </Form.Group>
                                            </Col>
                                        </>
                                        :
                                        radioType === 'D' ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={cbOutFromDate}
                                                            onChange={(date) => setCbOutFromDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={cbOutToDate}
                                                            onChange={(date) => setCbOutToDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            :
                                            null
                                }
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    {
                                        userRight.query === "1" && (radioType === 'S' || radioType === 'D') ?
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => list()}>List</Button>
                                            : null
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Table responsive striped bordered hover>
                                    <thead>
                                        <tr>
                                            {userRight.query === "1" ? <th></th> : null}
                                            <th>SrNo</th>
                                            <th>Date</th>
                                            <th>Bank</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            headerData?.map((res) =>
                                                <tr key={res.hdr_srno}>
                                                    {userRight.query === "1" ?
                                                        <td className="textCenter">
                                                            <span className="handCursor colorThemeBlue" onClick={() => viewList(res.hdr_srno, res.hdr_location, res.hdr_type, res.new_date)}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>
                                                        </td>
                                                        : null
                                                    }
                                                    <td>{res.hdr_srno}</td>
                                                    <td>{res.hdr_date}</td>
                                                    <td>{res.hdr_bank}</td>
                                                </tr>
                                            )}
                                        <tr></tr>
                                    </tbody>
                                </Table>
                            </Row>
                        </>
                        :
                        <>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={() => cancelConfirm()}>Back</Button>{' '}
                                    {/* &nbsp;<Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>&nbsp; */}
                                    {(userRight.edit === "1" && scrMode === 'Q') && <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => btnActivityLog()}>Activity Log</Button>&nbsp;
                                    </>
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Serial No : {srNo}</Form.Label>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>From Location : {fromLocation}</Form.Label>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>To Location : {toLocation}</Form.Label>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Bank : {bankName}</Form.Label>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Table responsive striped bordered hover>
                                    <thead>
                                        <tr>
                                            {userRight.query === "1" ? <th></th> : null}
                                            <th>Quantity</th>
                                            <th>From</th>
                                            <th>To</th>
                                            <th>Date</th>
                                            <th>Bank</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            innerData.map((val, index) =>
                                                <tr key={index}>
                                                    {
                                                        userRight.query === "1" ?
                                                            <td className="textCenter">
                                                                {
                                                                    scrMode === 'Q' ?
                                                                        <span className="handCursor colorThemeBlue" onClick={() => viewDetails(val.tcb_srno, val.tcb_line_no, val.tcb_location, val.tcb_type)}>
                                                                            <FontAwesomeIcon icon={faEye} />
                                                                        </span>
                                                                        : null
                                                                }
                                                            </td>
                                                            : null
                                                    }
                                                    <td>{val.tcb_quantity}</td>
                                                    <td>{val.tcb_from}</td>
                                                    <td>{val.tcb_to}</td>
                                                    <td>{val.tcb_date}</td>
                                                    <td>{val.tcb_group} {val.tcb_account} {val.tcb_bankname}</td>
                                                </tr>
                                            )}
                                    </tbody>
                                </Table>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>&nbsp;</Row>
                            <Row>&nbsp;</Row>
                        </>
                }
            </Container>
            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
                <Dialog isOpen={isErrBox} onClose={(e) => setErrBox(false)}>
                    {errText}
                </Dialog>
                <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
            </div>
            <div>
                <Modal size='lg' show={showModal} onHide={() => setShowModal(false)} animation={false} centered>
                    <Modal.Body>
                        <Container fluid>
                            <Row>
                                <Col>
                                    <Table responsive striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>From</th>
                                                <th>In Sr No.</th>
                                                <th>In Type</th>
                                                <th>In Line No.</th>
                                                {/* <th>In Location</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                subInnerData.map((res) =>
                                                    <tr key={res.tcb_line_no}>
                                                        <td>{res.tcbb_from}</td>
                                                        <td>{res.tcbb_srno}</td>
                                                        <td>{res.tcbb_type}</td>
                                                        <td>{res.tcbb_line_no}</td>
                                                        {/* <td>{res.tcbb_out_location}</td> */}
                                                        <td></td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-success" onClick={() => setShowModal(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            </div>
        </>
    )
}

export default Tran_cheque_in_view
